import React from 'react';

interface InfoItemProps {
        label: string;
        value: string;
}
// 派送页面 订单详情统一样式
const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => {
        return (
            <div className="flex justify-between py-2 border-gray-100">
                    <span className="text-gray-600 text-sm">{label}:</span>
                    <span className="text-sm font-medium text-right break-all">{value}</span>
            </div>
        );
};

export default InfoItem;
